// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 人脸识别 POST /api/v1/alipay/auth/face-recognition */
export async function AlipayAuthControllerFaceRecognitionV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputAlipayCertifyDataDto>(
    "/api/v1/alipay/auth/face-recognition",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}

/** 人脸识别结果查询 GET /api/v1/alipay/auth/face-recognition-result */
export async function AlipayAuthControllerFaceRecognitionResultV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AlipayAuthControllerFaceRecognitionResultV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/alipay/auth/face-recognition-result",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 支付宝小程序手机号登录 POST /api/v1/alipay/auth/sign-in */
export async function AlipayAuthControllerSignInV1(
  body: MyApi.AlipayMiniProgramSignInDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuthDto>(
    "/api/v1/alipay/auth/sign-in",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 支付宝小程序登录 - 通过 authCode 查找已绑定用户 POST /api/v1/alipay/auth/signInByCode */
export async function AlipayAuthControllerSignInByCodeV1(
  body: MyApi.AlipayMiniProgramSignInByCodeDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuthDto>(
    "/api/v1/alipay/auth/signInByCode",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
